import { render } from "./ReportesEmpresas.vue?vue&type=template&id=4e2eacb9"
import script from "./ReportesEmpresas.vue?vue&type=script&lang=js"
export * from "./ReportesEmpresas.vue?vue&type=script&lang=js"

import "./ReportesEmpresas.vue?vue&type=style&index=0&id=4e2eacb9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__